import {
  Code2,
  Smartphone,
  Globe,
  Brain,
  Workflow,
  ShoppingCart,
  Headset,
  Wallet,
  Lightbulb,
  ArrowRight,
} from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import seloDatacaixa from "@/assets/selo-datacaixa.png";

const Services = () => {
  const services = [
    {
      icon: Code2,
      title: "Desenvolvimento de Sistemas Personalizados",
      description:
        "Criamos sistemas sob medida para atender as necessidades específicas do seu negócio, com tecnologias modernas e escaláveis.",
    },
    {
      icon: Smartphone,
      title: "Desenvolvimento de Aplicativos Mobile",
      description:
        "Apps nativos e híbridos para iOS e Android, com design intuitivo e performance otimizada para a melhor experiência do usuário.",
    },
    {
      icon: Globe,
      title: "Sites e Lojas Virtuais",
      description: "Websites institucionais, e-commerce e landing pages responsivas, otimizadas para SEO e conversão.",
    },
    {
      icon: Brain,
      title: "Integração de Inteligência Artificial",
      description:
        "Implemente IA nos seus processos: chatbots, análise de dados, automação inteligente e machine learning.",
    },
    {
      icon: Workflow,
      title: "Automações de Sistemas",
      description: "Automatize processos repetitivos, integre sistemas diferentes e aumente a eficiência operacional.",
    },
    {
      icon: ShoppingCart,
      title: "Sistema de Ponto de Venda",
      description:
        "O Sistema PDV é uma solução completa para controle de vendas, caixa, comandas, mesas, pedidos e delivery, com emissão de NFC-e Modelo 65.",
    },
    {
      icon: Headset,
      title: "Sistema de Controle de Chamados",
      description:
        "Gerencie demandas, tickets e atendimento ao cliente com nosso sistema completo de gestão de chamados.",
    },
    {
      icon: Wallet,
      title: "Controle Financeiro Pessoal",
      description:
        "Sistema inteligente para gerenciar suas finanças pessoais, com categorização, relatórios e alertas.",
    },
    {
      icon: Lightbulb,
      title: "Consultoria em Tecnologia",
      description:
        "Orientação estratégica para transformação digital, escolha de tecnologias e otimização de processos.",
    },
  ];

  return (
    <section id="services" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Nossos <span className="text-primary">Serviços</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Soluções completas em tecnologia para transformar seu negócio
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <Card
              key={index}
              className="p-6 hover:shadow-xl transition-all duration-300 card-shadow group hover:-translate-y-1 hover:border-primary/50"
            >
              <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary group-hover:glow-primary transition-all">
                <service.icon
                  className="text-primary group-hover:text-primary-foreground transition-colors"
                  size={28}
                />
              </div>
              <h3 className="text-xl font-bold mb-3">{service.title}</h3>
              <p className="text-muted-foreground mb-4 leading-relaxed">{service.description}</p>
              <Button
                variant="ghost"
                size="sm"
                className="group/btn p-0 h-auto"
                onClick={() => {
                  const message = encodeURIComponent(`Olá! Gostaria de saber mais sobre: ${service.title}`);
                  window.open(`https://wa.me/5504420181162?text=${message}`, "_blank");
                }}
              >
                Saiba mais
                <ArrowRight className="ml-2 group-hover/btn:translate-x-1 transition-transform" size={16} />
              </Button>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
